var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home_box flex_all" }, [
    _c("div", { staticClass: "login_box flex" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "login_right" },
        [
          _c("img", {
            staticClass: "shopvidi_logo",
            attrs: { src: require("@/assets/img/shopvidi_logo.png"), alt: "" }
          }),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "registerForm",
              attrs: { model: _vm.registerForm, rules: _vm.rules }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "username",
                    rules: {
                      required: true,
                      validator: _vm.userNameCheck,
                      trigger: ["blur", "change"]
                    }
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "First Name",
                      oninput: "if(value){value=value.toLowerCase()}",
                      onblur: "if(value){value=value.trim()}"
                    },
                    model: {
                      value: _vm.registerForm.firstName,
                      callback: function($$v) {
                        _vm.$set(_vm.registerForm, "firstName", $$v)
                      },
                      expression: "registerForm.firstName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "username",
                    rules: {
                      required: true,
                      validator: _vm.userNameCheck2,
                      trigger: ["blur", "change"]
                    }
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Last Name",
                      oninput: "if(value){value=value.toLowerCase()}",
                      onblur: "if(value){value=value.trim()}"
                    },
                    model: {
                      value: _vm.registerForm.lastName,
                      callback: function($$v) {
                        _vm.$set(_vm.registerForm, "lastName", $$v)
                      },
                      expression: "registerForm.lastName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "email",
                    rules: [
                      {
                        required: true,
                        message: "Please enter the email",
                        trigger: ["blur", "change"]
                      },
                      { validator: _vm.checkEmail, trigger: ["blur", "change"] }
                    ]
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Business Email",
                      oninput: "if(value){value=value.toLowerCase()}",
                      onblur: "if(value){value=value.trim()}"
                    },
                    model: {
                      value: _vm.registerForm.email,
                      callback: function($$v) {
                        _vm.$set(_vm.registerForm, "email", $$v)
                      },
                      expression: "registerForm.email"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "flex cust-form-item cust-form-item2",
                  attrs: { prop: "phone" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "+ Country Code" },
                      on: { change: _vm.codeChange },
                      model: {
                        value: _vm.codeObject,
                        callback: function($$v) {
                          _vm.codeObject = $$v
                        },
                        expression: "codeObject"
                      }
                    },
                    _vm._l(_vm.options, function(item, index) {
                      return _c(
                        "el-option",
                        {
                          key: index,
                          attrs: { label: item.text, value: item }
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(_vm._s(item.text))
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "right",
                                color: "#8492a6",
                                "font-size": "13px"
                              }
                            },
                            [_vm._v(_vm._s(item.value))]
                          )
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: { placeholder: "Phone" },
                    on: { input: _vm.changePhone },
                    model: {
                      value: _vm.registerForm.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.registerForm, "phone", $$v)
                      },
                      expression: "registerForm.phone"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "cust-form-item",
                  attrs: {
                    prop: "password",
                    rules: {
                      validator: _vm.handlePasswordLevel,
                      trigger: "change"
                    }
                  }
                },
                [
                  _c(
                    "el-popover",
                    {
                      ref: "popover",
                      attrs: {
                        placement: "top-start",
                        width: "200px",
                        trigger: "focus"
                      }
                    },
                    [
                      _c(
                        "div",
                        { style: "color:" + _vm.levelColor[_vm.levelStatus] },
                        [
                          _c("i", { class: _vm.levelClass[_vm.levelStatus] }),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.levelNames[_vm.levelStatus]) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        _vm._l(_vm.levelNames, function(item, id) {
                          return id > 0
                            ? _c("el-progress", {
                                key: id,
                                staticStyle: { width: "33%" },
                                attrs: {
                                  percentage:
                                    id > _vm.levelStatus
                                      ? 0
                                      : id < _vm.levelStatus
                                      ? 100
                                      : _vm.levelPercent,
                                  "show-text": false,
                                  color: _vm.levelColor[_vm.levelStatus]
                                }
                              })
                            : _vm._e()
                        }),
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-input",
                    {
                      directives: [
                        {
                          name: "popover",
                          rawName: "v-popover:popover",
                          arg: "popover"
                        }
                      ],
                      attrs: {
                        type: _vm.passw,
                        autocomplete: "new-password",
                        placeholder: "Password"
                      },
                      on: { focus: _vm.changeType },
                      model: {
                        value: _vm.registerForm.password,
                        callback: function($$v) {
                          _vm.$set(_vm.registerForm, "password", $$v)
                        },
                        expression: "registerForm.password"
                      }
                    },
                    [
                      _c(
                        "i",
                        {
                          attrs: { slot: "suffix" },
                          on: { click: _vm.showPass },
                          slot: "suffix"
                        },
                        [
                          _vm.passw == "password"
                            ? _c("img", {
                                staticClass: "reg-show-hide-icon",
                                attrs: {
                                  src: require("@/assets/img/icon-hide.png"),
                                  alt: ""
                                }
                              })
                            : _c("img", {
                                staticClass: "reg-show-hide-icon",
                                attrs: {
                                  src: require("@/assets/img/icon-show.png"),
                                  alt: ""
                                }
                              })
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "text_agreen_register" }, [
                _vm._v("By clicking Login, you agree to our "),
                _c(
                  "a",
                  { attrs: { href: "https://www.shopvidi.com/term-service" } },
                  [
                    _c("span", { staticClass: "organ_color" }, [
                      _vm._v("Terms of Service")
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "primary", disabled: _vm.loading },
                  on: {
                    click: function($event) {
                      return _vm.submitForm("registerForm")
                    }
                  }
                },
                [_vm._v("Next\n        ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "text_agreen_register" }, [
                _vm._v("Already have ShopVidi account?"),
                _c(
                  "span",
                  { staticClass: "login-now", on: { click: _vm.changeForm } },
                  [_vm._v("Log in now")]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login_left" }, [
      _c("p", { staticClass: "info" }, [
        _c("span", [_vm._v("ShopVidi")]),
        _vm._v(
          " - Global Brands, Local Retailers, One\n        Entrepreneur Dream!\n      "
        )
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "login_img",
        attrs: {
          src:
            "https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-login_img.png",
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "icon_line_box" }, [
        _c("div", { staticClass: "icon_line flex" }, [
          _c("img", {
            staticClass: "icon_img",
            attrs: {
              src:
                "https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line1.png",
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "text_p2" }, [
            _vm._v("Access to numerous retailers across the states")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "icon_line flex" }, [
          _c("img", {
            staticClass: "icon_img",
            attrs: {
              src:
                "https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line2.png",
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "text_p2" }, [
            _vm._v("Guaranteed payments on every order")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "icon_line flex" }, [
          _c("img", {
            staticClass: "icon_img",
            attrs: {
              src:
                "https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line3.png",
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "text_p2" }, [
            _vm._v("Risk-free terms extended to retailers")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "icon_line flex" }, [
          _c("img", {
            staticClass: "icon_img",
            attrs: {
              src:
                "https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line4.png",
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "text_p2" }, [
            _vm._v(
              "Retailer veriﬁcation, payment collection, & customer support"
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "icon_line flex" }, [
          _c("img", {
            staticClass: "icon_img",
            attrs: {
              src:
                "https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line5.png",
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "text_p2" }, [
            _vm._v("Analytics, and tools to streamline your business")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe15113a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe15113a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/register/register.vue
// module id = GFs5
// module chunks = 2